export default __webpack_public_path__ + "static/app-4-3edea0eccf727ab11ca693dc64986384.webp";